// bundle-card multi-row version
(() => {
  const root = document.querySelector('[data-buy-x-get-y-root]');
  if (!root) return;

  const dataEl = root.querySelector('[data-buy-x-get-y-data]');
  const bundleEl = root.querySelector('[data-buy-x-get-y-bundle]');
  const selectedVariantInput = root.querySelector('[data-buy-x-get-y-selected-variant]');
  const errorEl = root.querySelector('[data-buy-x-get-y-error]');
  const addToCartTextEl = document.querySelector('#product-form__button_addtocart_text');
  const offerVariantIds = (root.dataset.offerVariantIds || '')
          .split(',')
          .map(s => s.trim())
          .filter(Boolean);

  if (!dataEl || !bundleEl || !selectedVariantInput) return;

  const selectionTypeRaw = root.dataset.selectionType || 'single';
  const selectionType = selectionTypeRaw.trim().toLowerCase();

  const mode = (selectionType === 'all') ? 'all'
            : (selectionType === 'multiple' || selectionType === 'multi') ? 'multiple'
            : 'single';

  const isMulti = mode === 'multiple' || mode === 'all';

  if (mode === 'all') {
    root.classList.add('block-buy-x-get-y--all');
  }

  let offersRaw = [];
  try {
    offersRaw = JSON.parse(dataEl.textContent || '[]');
  } catch (e) {
    console.warn('Offer JSON parse failed', e);
    return;
  }
  if (!Array.isArray(offersRaw) || offersRaw.length === 0) return;

  // ---------- helpers ----------
  const uniq = (arr) => Array.from(new Set(arr));
  const norm = (s) => (s || '').trim().toLowerCase();

  const normaliseOptions = (optArray) => {
    const map = {};
    (optArray || []).forEach((o) => {
      if (!o || !o.label) return;
      map[String(o.label)] = String(o.value ?? '');
    });
    return map;
  };

  const offers = offersRaw.map(g => ({
    ...g,
    optionMap: normaliseOptions(g.options)
  }));

  // Remove auto selection for free offers to let customers choose (can be re-enabled if desired)
  // const hasFreeOffer = offers.some(g => g.discount_type === 'Free');

  // ---------- Option Sync (main product -> offer rows) ----------
  const SYNC_LABELS = ['style', 'colour', 'color', 'size'];

  const normaliseLabel = (label) => {
    const n = norm(label);
    return n === 'color' ? 'colour' : n; // treat Color as Colour
  };

  const getMainOptionValue = (label) => {
    const target = normaliseLabel(label);

    // Find option container (group or heading)
    const containers = Array.from(document.querySelectorAll('.option-group, .option-heading'));

    const container = containers.find(c => {
      const lbl =
        c.querySelector('.option-label')?.textContent ||
        c.querySelector('legend')?.textContent ||
        '';
      return normaliseLabel(lbl) === target;
    });

    if (!container) return null;

    // ✅ Robust active pill detection (covers class + aria)
    const active =
      container.querySelector('.pill-group .pill.active') ||
      container.querySelector('.pill-group .pill[aria-pressed="true"]') ||
      container.querySelector('.pill-group .pill[aria-checked="true"]');

    if (!active) return null;

    // Image pill (Style/Colour)
    const imgAlt = active.querySelector('img')?.getAttribute('alt');
    if (imgAlt) return imgAlt.trim();

    // Text pill (Size)
    const txt = active.textContent?.trim();
    if (txt) return txt;

    // Fallback: selected value display (if theme uses it)
    const raw = container.querySelector('.option-selected-value')?.textContent || '';
    const cleaned = raw.replace(':', '').trim();
    return cleaned || null;
  };

  // ---------- group by Parent ----------
  const groupMap = new Map();
  offers.forEach(g => {
    const key = (g.parent && String(g.parent).trim()) ? String(g.parent).trim() : 'Other';
    if (!groupMap.has(key)) groupMap.set(key, []);
    groupMap.get(key).push(g);
  });

  const groups = Array.from(groupMap.entries()).map(([parent, items]) => ({ parent, items }));

  // ---------- label ordering ----------
  const PRIORITY_LABELS = ['style', 'colour', 'color', 'size'];

  const orderLabels = (labels) => {
    const raw = uniq(labels).filter(Boolean);
    return raw.sort((a, b) => {
      const na = norm(a);
      const nb = norm(b);

      const pa = PRIORITY_LABELS.indexOf(na);
      const pb = PRIORITY_LABELS.indexOf(nb);

      if (pa !== -1 && pb !== -1) return pa - pb;
      if (pa !== -1) return -1;
      if (pb !== -1) return 1;
      return na.localeCompare(nb);
    });
  };

  // ---------- size value ordering ----------
  const baseSizes = [
    "2XS","XXS","XS","XS-20","XS-28","XS/S","XS-S","S","S-22","S-28","S-30","S-31","S/M","S-M","M","M-24","M-32","M-33","M-34","M - Regular","M/L","M-L","L","L-26","L-34","L - Regular","L - Slim","L/XL","L-XL","XL","XL-28","XL-34","XL-36","XL/2XL","XL-2XL","2XL","2XL-38","XXL","3XL","3XL-40","XXXL","4XL","XXXXL",
    "XS - 122mm","S - 126mm","M - 133mm","L - 122mm","L - 134mm","L - 135mm","XL - 137mm","XL - 138mm",
    "One Size Fits Most","OSFA",
    "3","4","5","5.0","5.5","6","6.0","6.5","7","7.0","7.5","8","8.0","8.5","9","9.0","9.5","10","10.0","10C","10.5","11","11.0","11.5","12","12.0","12.5","13","13.0","13.5","14","14.0","14.5","15","15.0",
    "8-10","10-13"
  ];

  const sizeOrder = [
    ...baseSizes,
    ...baseSizes.map(size => `Women's ${size}`),
    ...baseSizes.map(size => `Youth ${size}`),
    ...baseSizes.map(size => `Youth - ${size}`),
    ...baseSizes.map(size => `Kids ${size}`),
    ...baseSizes.map(size => `US ${size}`),
    ...baseSizes.map(size => `Child ${size}`),
    ...baseSizes.map(size => `Toddler ${size}`),
    ...baseSizes.map(size => `Women's US ${size}`)
  ];

  const sizeIndexMap = new Map(sizeOrder.map((s, i) => [norm(s), i]));

  const sortValues = (label, values) => {
    const la = norm(label);

    // size ordering
    if (la === 'size') {
      return values.slice().sort((a, b) => {
        const ia = sizeIndexMap.get(norm(a));
        const ib = sizeIndexMap.get(norm(b));
        if (ia !== undefined && ib !== undefined) return ia - ib;
        if (ia !== undefined) return -1;
        if (ib !== undefined) return 1;
        return a.localeCompare(b);
      });
    }

    // default alpha
    return values.slice().sort((a, b) => a.localeCompare(b));
  };

  // ---------- selection + ATC text ----------
  const rowControllers = [];

  let selectAllEl = null;        // master checkbox element (ALL mode)
  
  const updateATCText = (hasAnySelected) => {
    if (!addToCartTextEl) return;

    // ✅ Do not override Sold Out state
    if (addToCartTextEl.textContent.trim().toLowerCase() === 'sold out') {
      return;
    }

    addToCartTextEl.textContent = hasAnySelected ? 'Add To Cart + Add-on' : 'Add To Cart';
  };

  const updateSelectedVariants = () => {
    const selectedItems = rowControllers
      .filter(r => r.checkbox.checked)
      .map(r => {
        const offer = r.currentOffer;

        // skip invalid rows
        if (!offer || !offer.variant_id) return null;

        return {
          id: offer.variant_id,
          offer: offer.offer_title || 'Unknown offer'
        };
      })
      .filter(Boolean);

    // ✅ Store richer data instead of just IDs
    selectedVariantInput.value = JSON.stringify(selectedItems);

    updateATCText(selectedItems.length > 0);
  };


  // ---------- Bundle availability ----------
  const isMainProductSoldOut = () => {
    if (!addToCartTextEl) return false;
    return addToCartTextEl.textContent.trim().toLowerCase() === 'sold out';
  };
  const updateBundleAvailability = () => {
    const soldOut = isMainProductSoldOut();

    rowControllers.forEach(r => {
      // Disable checkbox
      r.checkbox.disabled = soldOut;

      // Force unchecked if sold out
      if (soldOut) {
        r.checkbox.checked = false;
        r.row.classList.remove('is-selected');
      }

      // Add visual state class
      r.row.classList.toggle('is-disabled', soldOut);
    });

    // Also handle "select all"
    if (selectAllEl) {
      selectAllEl.disabled = soldOut;
      if (soldOut) selectAllEl.checked = false;
    }

    updateSelectedVariants();
  };

  // ---------- Offer Visibility -----
  const getCurrentVariantId = () => {
    const input = document.querySelector('#product-form__variantid');
    //const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? String(input.value) : null;
  };
  const updateOfferVisibility = () => {
    const currentId = getCurrentVariantId();

    const shouldShow =
      currentId &&
      offerVariantIds.length &&
      offerVariantIds.includes(currentId);

    root.style.display = shouldShow ? '' : 'none';

    if (!shouldShow) {
      rowControllers.forEach(r => {
        r.checkbox.checked = false;
        r.row.classList.remove('is-selected');
      });

      if (selectAllEl) selectAllEl.checked = false;

      selectedVariantInput.value = '[]';
      updateATCText(false);
    }
  };

  // ---------- row builder ----------
  const buildRow = (group, idx) => {
    const row = document.createElement('div');
    row.className = 'block-buy-x-get-y__bundle-row';
    row.dataset.parent = group.parent;

    const parentLabel = group.parent || '';

    const checkboxId = `addon-row-${idx}`;

    row.innerHTML = `
      ${parentLabel ? `
        <div class="block-buy-x-get-y__row-parent">
          <span class="block-buy-x-get-y__parent-text">${parentLabel}</span>

          <a class="block-buy-x-get-y__open" data-row-open href="#" target="_blank" rel="noopener">
            <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="currentColor" d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3z"/>
              <path fill="currentColor" d="M5 5h7v2H7v10h10v-5h2v7H5V5z"/>
            </svg>
          </a>
        </div>
      ` : ''}

      <div class="block-buy-x-get-y__col-select">
        <input class="block-buy-x-get-y__checkbox" type="checkbox" id="${checkboxId}" data-row-enable ${mode === 'all' ? 'tabindex="-1" aria-hidden="true"' : ''}>
        ${mode !== 'all' ? `<label class="block-buy-x-get-y__checkbox-ui" for="${checkboxId}"></label>` : ''}
      </div>

      <div class="block-buy-x-get-y__col-media">
        <img class="block-buy-x-get-y__image" data-row-image src="" alt="" loading="lazy" width="72" height="72">
      </div>

      <div class="block-buy-x-get-y__col-info">
        <div class="block-buy-x-get-y__row block-buy-x-get-y__row--filters" data-row-filters></div>

        <div class="block-buy-x-get-y__row block-buy-x-get-y__row--prices">
          <span class="block-buy-x-get-y__price-plus">+</span>
          <span class="block-buy-x-get-y__price-final" data-row-price-final></span>
          <span class="block-buy-x-get-y__price-save" data-row-price-save></span>
          <span class="block-buy-x-get-y__price-original" data-row-price-original></span>
        </div>
      </div>
    `;

    const checkbox = row.querySelector('[data-row-enable]');
    const imgEl = row.querySelector('[data-row-image]');
    const filtersElRow = row.querySelector('[data-row-filters]');
    const priceFinalEl = row.querySelector('[data-row-price-final]');
    const priceSaveEl = row.querySelector('[data-row-price-save]');
    const priceOriginalEl = row.querySelector('[data-row-price-original]');
    const openEl = row.querySelector('[data-row-open]');

    // per-row labels (union of available optionMap keys)
    const rowLabels = orderLabels(
      group.items.flatMap(it => Object.keys(it.optionMap || {}))
    );
    
    // per-row state
    const rowState = {};
    const rowSelects = new Map();

    // --- Variant-matrix helpers (per row) ---
    const filterItems = (criteria) => {
      return group.items.filter(it =>
        Object.entries(criteria).every(([k, v]) => (it.optionMap?.[k] || '') === v)
      );
    };

    const allowedValuesFor = (label, criteria) => {
      return uniq(
        filterItems(criteria)
          .map(it => it.optionMap?.[label])
          .filter(Boolean)
      );
    };

    // Resolve state so every label selection is valid given previous selections
    const resolveRowMatrix = () => {
      const resolved = { ...rowState };

      for (let i = 0; i < rowLabels.length; i++) {
        const label = rowLabels[i];

        const criteria = {};
        for (let j = 0; j < i; j++) {
          criteria[rowLabels[j]] = resolved[rowLabels[j]];
        }

        const allowed = allowedValuesFor(label, criteria);
        if (!allowed.length) continue;

        if (!allowed.includes(resolved[label])) {
          // Pick first allowed (sorted later in refresh)
          resolved[label] = allowed[0];
        }
      }

      // Commit resolved back into rowState
      rowLabels.forEach(l => { rowState[l] = resolved[l]; });
    };

    // Disable invalid options per select based on previous selections
    const refreshRowAvailability = () => {
      for (let i = 0; i < rowLabels.length; i++) {
        const label = rowLabels[i];
        const sel = rowSelects.get(label);
        if (!sel) continue;

        const criteria = {};
        for (let j = 0; j < i; j++) {
          criteria[rowLabels[j]] = rowState[rowLabels[j]];
        }

        const allowed = allowedValuesFor(label, criteria);
        // Sort allowed using your existing sorter so size ordering still applies
        const allowedSorted = sortValues(label, allowed);

        Array.from(sel.options).forEach(opt => {
          opt.disabled = !allowedSorted.includes(opt.value);
        });

        // If current selection is not allowed, snap to first allowed
        if (allowedSorted.length && !allowedSorted.includes(sel.value)) {
          sel.value = allowedSorted[0];
          rowState[label] = allowedSorted[0];
        }
      }
    };
    // Track whether the user has manually changed a specific label in this row
    const touched = {}; // { true/false }

    // init rowState with first item’s values
    const first = group.items[0];
    rowLabels.forEach(l => {
      const v = first.optionMap?.[l] || '';
      rowState[l] = v;
    });

    const findMatch = () => {
      // exact match based on rowState for these labels
      const hit = group.items.find(it =>
        rowLabels.every(l => (it.optionMap?.[l] || '') === (rowState[l] || ''))
      );
      return hit || group.items[0];
    };

    const applyOffer = (offer) => {
      imgEl.src = offer.image || '';
      imgEl.alt = offer.title || '';

      priceFinalEl.textContent = offer.price_final || '';

      // ✅ Handle discount types cleanly
      if (offer.discount_type === 'No Discount') {
        // ✅ No discount UI
        priceOriginalEl.textContent = '';
        priceOriginalEl.style.display = 'none';

        priceSaveEl.textContent = '';
        priceSaveEl.style.display = 'none';
      } else {
        // ✅ Discounted UI
        priceOriginalEl.textContent = offer.price_original || '';
        priceOriginalEl.style.display = offer.price_original ? '' : 'none';

        priceSaveEl.textContent = offer.price_save || '';
        priceSaveEl.style.display = offer.price_save ? '' : 'none';
      }

      if (offer.url) {
        openEl.href = offer.url;
        openEl.style.display = '';
      } else {
        openEl.style.display = 'none';
      }

      controller.currentOffer = offer;
      updateSelectedVariants();
    };

    // render dropdowns for this row
    filtersElRow.innerHTML = '';
    rowLabels.forEach(label => {
      const values = uniq(group.items.map(i => i.optionMap?.[label]).filter(Boolean));
      if (values.length <= 1) {
        rowState[label] = values[0] || rowState[label] || '';
        return;
      }

      const sorted = sortValues(label, values);

      const wrap = document.createElement('div');
      wrap.className = 'block-buy-x-get-y__filter';

      const lab = document.createElement('div');
      lab.className = 'block-buy-x-get-y__filter-label';
      lab.textContent = label;

      const sel = document.createElement('select');
      sel.className = 'block-buy-x-get-y__filter-select';

      sorted.forEach(v => {
        const opt = document.createElement('option');
        opt.value = v;
        opt.textContent = v;
        sel.appendChild(opt);
      });

      if (!sorted.includes(rowState[label])) rowState[label] = sorted[0];
      sel.value = rowState[label];

      sel.addEventListener('change', (e) => {
        const nLabel = normaliseLabel(label);

        // Update state
        rowState[label] = sel.value;

        // Re-resolve matrix + disable invalid options (this is the key fix)
        resolveRowMatrix();
        refreshRowAvailability();

        // Only user-initiated changes affect sync lock for this label
        // if (e.isTrusted) {
        //   requestAnimationFrame(() => {
        //     const mainVal = getMainOptionValue(label);
        //     if (mainVal) {
        //       touched[nLabel] = norm(rowState[label]) !== norm(mainVal);
        //     } else {
        //       touched[nLabel] = false;
        //     }
        //   });
        // }
        
        if (e.isTrusted) {
          // ✅ Immediately mark this label as user-controlled
          touched[nLabel] = true;
        }

        applyOffer(findMatch());
      });

      wrap.appendChild(lab);
      wrap.appendChild(sel);
      filtersElRow.appendChild(wrap);

      rowSelects.set(label, sel);
    });

    resolveRowMatrix();
    refreshRowAvailability();

    rowLabels.forEach(label => {
      const sel = rowSelects.get(label);
      if (sel && sel.value !== rowState[label]) sel.value = rowState[label];
    });

    const controller = {
      parent: group.parent,
      row,
      checkbox,
      currentOffer: null
    };

    row.addEventListener('click', (e) => {
      if (mode === 'all') return; // ✅ disable row-level toggle

      // ✅ Ignore interactive elements (including checkbox itself)
      const interactive = e.target.closest('select, option, a, button, label, input');
      if (interactive) return;

      // ✅ Toggle checkbox
      checkbox.checked = !checkbox.checked;

      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // checkbox behaviour per selection type
    checkbox.addEventListener('change', () => {
      if (!isMulti && checkbox.checked) {
        rowControllers.forEach(r => {
          if (r !== controller) {
            r.checkbox.checked = false;
            r.row.classList.remove('is-selected'); // ✅ remove old selection
          }
        });
      }

      // ✅ Toggle selected state ON THIS ROW
      row.classList.toggle('is-selected', checkbox.checked);

      updateSelectedVariants();
    });

    // init with best match
    applyOffer(findMatch());

    controller.syncFromMain = () => {
      // Only sync labels that exist in both main product and this row’s dropdowns
      rowLabels.forEach(label => {
        const nLabel = normaliseLabel(label);
        if (!SYNC_LABELS.includes(nLabel)) return;

        // If user has manually set this label in this row, do not override it
        if (touched[nLabel]) return;

        const mainVal = getMainOptionValue(label);
        if (!mainVal) return;

        const sel = rowSelects.get(label);
        if (!sel) return;

        const desired = norm(mainVal);

        const opts = Array.from(sel.options);
        const match =
          opts.find(o => norm(o.text || '') === desired) ||
          opts.find(o => norm(o.value || '') === desired);

        if (!match || match.disabled) return;
        if (sel.value === match.value) return;

        // Programmatic change: do NOT mark touched (isTrusted will be false)
        sel.value = match.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };
    return controller;
  };

  // ---------- render bundle rows ----------
  bundleEl.innerHTML = '';
  rowControllers.length = 0;

  // ✅ If mode is ALL, inject one master checkbox anchored to the checkbox column
  if (mode === 'all') {
    const selectAllId = 'addon-select-all';

    const masterWrap = document.createElement('div');
    masterWrap.className = 'block-buy-x-get-y__select-all-row';

    masterWrap.innerHTML = `
      <div class="block-buy-x-get-y__col-select">
        <input class="block-buy-x-get-y__checkbox" type="checkbox" id="${selectAllId}" data-select-all>
        <label class="block-buy-x-get-y__checkbox-ui" for="${selectAllId}"></label>
      </div>

      <div class="block-buy-x-get-y__col-info">
        <div class="block-buy-x-get-y__select-all-text">
          Add all items to unlock this offer
        </div>
      </div>
    `;

    bundleEl.appendChild(masterWrap);
    selectAllEl = masterWrap.querySelector('[data-select-all]');
  }

  groups.forEach((g, idx) => {
    const controller = buildRow(g, idx);
    rowControllers.push(controller);
    bundleEl.appendChild(controller.row);
  });

  // ✅ Master checkbox logic (ALL mode only)
  if (selectAllEl) {
    // In ALL mode: single decision, no partial state
    selectAllEl.addEventListener('change', () => {
      const checked = selectAllEl.checked;

      rowControllers.forEach(r => {
        r.checkbox.checked = checked;
        r.row.classList.toggle('is-selected', checked);
      });

      updateSelectedVariants();
    });

    // Ensure starting state is consistent
    selectAllEl.checked = false;
  }


  // ---------- Run initial sync ----------
  const syncAllRowsFromMain = () => {
    rowControllers.forEach(r => r.syncFromMain && r.syncFromMain());
  };

  syncAllRowsFromMain();

  // ---------- Observe main PDP option changes (pills toggle class / DOM re-render) ----------
  const stableRoot =
    document.querySelector('#ProductInfo') ||
    document.querySelector('form[action*="/cart/add"]') ||
    document.querySelector('main') ||
    document.body;

  let pending = false;
  const scheduleSync = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      syncAllRowsFromMain();
      updateOfferVisibility();
      updateBundleAvailability();
    });
  };

  const observer = new MutationObserver(scheduleSync);
  observer.observe(stableRoot, {
    subtree: true,
    childList: true,
    attributes: true,
    characterData: true
  });

  // ✅ Click fallback: ensures sync runs even when DOM mutations are minimal
  document.addEventListener('click', (e) => {
    if (e.target.closest('.option-group .pill, .option-heading .pill')) {
      scheduleSync();
    }
  }, true);

  // start unselected by default
  rowControllers.forEach(r => {
    r.checkbox.checked = false;
    r.row.classList.remove('is-selected'); // ✅ ensure clean state
  });

  // Note: if you want to auto-select the first offer when a free offer is present, you can re-enable this block. Just be aware it may override user choice if they change options after page load.
  // // ✅ Auto-select first offer product if FREE
  // if (hasFreeOffer && rowControllers.length) {
  //   const firstRow = rowControllers[0];

  //   firstRow.checkbox.checked = true;
  //   firstRow.row.classList.add('is-selected');
  // }

  updateSelectedVariants();
  updateOfferVisibility();
  updateBundleAvailability();

  if (selectAllEl) selectAllEl.checked = false;
})();